import datapoints from '../../datapoints';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { userMailInteractionAction } from 'owa-mail-actions';
import markAsJunkService from 'owa-mail-store/lib/services/markAsJunkService';
import reportMessageToSafetyLibraryService from 'owa-mail-triage-action/lib/services/reportMessageToSafetyLibraryService';
import * as undoActions from 'owa-mail-undo';
import { action } from 'satcheljs/lib/legacy';
/**
 * mark item as junk action
 * @param itemIds of the items to be marked as junk/not junk
 * @param isJunkValueToSet used to determine whether the item should be marked as junk
 * @param actionSource the action source where this action is triggered
 */
export default action('markItemsJunkNotJunkBasedOnItemIds', datapoints.markItemsJunkNotJunkDatapoint)(function markItemsJunkNotJunkBasedOnItemIds(itemIds, isJunkValueToSet, actionSource, instrumentationContexts, markItemsJunkNotJunkStoreUpdate) {
    undoActions.clearLastUndoableAction();
    var isConsumer = isControlFeatureEnabled('doc-consumerUrl');
    try {
        if (isConsumer) {
            reportMessageToSafetyLibraryService(itemIds, isJunkValueToSet ? 1 /* Junk */ : 2 /* NotJunk */);
        }
        else {
            markAsJunkService(itemIds, isJunkValueToSet);
        }
    }
    catch (error) {
        // VSO 19006: Handle triage action service error
    }
    markItemsJunkNotJunkStoreUpdate();
    if (isJunkValueToSet) {
        userMailInteractionAction('MarkAsJunk', instrumentationContexts);
    }
});
//# sourceMappingURL=markItemsJunkNotJunkBasedOnItemIds.js.map